export enum LocationStatusEnum {
  Active = 1,
  Inactive = 2,
}
export enum LocationTypeEnum {
  Root = 1,
  Undefined = 2,
  Other = 3,
  Country = 4,
  State = 5,
  City = 6,
  District = 7,
  Street = 8,
  Abroad = 9,
  Wildcard = 10,
}

export enum AnnouncementTypeEnum {
  Vacancy = 1,
  Training = 2,
  Tender = 3,
  Other = 4,
}

export enum EmploymentFormEnum {
  FullTime = 1,
  PartTime = 2,
  Flexible = 3,
  Freelance = 4,
  SeasonalTemporary = 5,
  Internship = 6,
}

export enum AnnouncementModuleEnum {
  Standard = 1,
  Exclusive = 2,
}

export enum AnnouncementListingSectionEnum {
  VipCV = -1,
  Vip = 1,
  Exclusive = 2,
  P4 = 3,
  P2 = 4,
  P1 = 5,
  Regular = 7,
  Preview = 8,
}

export enum ApplicationMethodEnum {
  EmailPhoneAddress = 1,
  ViaWebsite = 2,
  RedirectToUrl = 3,
}

export enum AnnouncementStatusEnum {
  Active = 1,
  Inactive = 2,
  Expired = 3,
  Canceled = 4,
}

export enum AnnouncementPublishStatusEnum {
  NotPublished = 1,
  LimitedPublish = 2,
  Published = 3,
  UnPublished = 4,
}

export enum ModerationStatusEnum {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Overriden = 4,
}

export enum AnnouncementModerationAttributeEnum {
  Type = 1,
  CustomerName = 2,
  Title = 3,
  Title2 = 4,
  Description = 5,
  Description2 = 6,
  IsAnonymous = 7,
  IsWithLogo = 8,
  OccupationCategory = 9,
  ContactPerson = 10,
  HideContactPerson = 11,
  EmploymentType = 12,
  BusinessTravel = 13,
  DurationFrom = 14,
  DurationTo = 15,
  SalaryFrom = 16,
  SalaryTo = 17,
  HideSalary = 18,
  RequiredLanguage = 19,
  WorkExperienceFrom = 20,
  WorkExperienceTo = 21,
  EducationLevel = 22,
  DrivingLicence = 23,
  Logo_Main = 24,
  Logo_Thumbnail1 = 25,
  Attachment = 26,
  ApplicationMethod = 27,
  Application_Email = 28,
  Application_IsEmailSameAsContactPerson = 29,
  Application_PhoneNumber = 30,
  Application_ApplicationUrl = 31,
  Application_ApplicationAddress = 32,
  PublishDate = 33,
  DeadlineDate = 34,
  IsWithBonus = 35,
  IsSuitableForStudent = 36,
  IsWorkFromHome = 37,
  BonusFrom = 38,
  WorkExperienceType = 39,
  ExtendedLocations = 40,
  AnnouncementRequirementIndustry = 41,
  EmploymentForm = 42,
  AnnouncementRequirementSeniorityLevel = 43,
  EmploymentRequirementIndustry = 44,
  AnnouncementRequirementSpecialization = 45,
  EmploymentRequirementSpecialization = 46,
  IsSpecializationSameAsVacancyRequirements = 47,
  IsIndustrySameAsVacancyRequirements = 48,
  IsSpecializationMandatory = 49,
  IsIndustryMandatory = 50,
  BonusTo = 51,
  Benefit = 52,
  EmployerRequirementSeniorityLevel = 53,
  HasTransport = 54,
  TransportType = 55,
  IsSeniorityLevelSameAsVacancyRequirements = 56,
  EducationProgram = 57,
  IsTravelRequired = 58,
  IsTravelAbroad = 59,
  IsTravelDomestic = 60,
  TravelPercentage = 61,
  IsWorkExperienceYearsIgnored = 62,
  IsWorkExperienceYearsMandatory = 63,
  IsSpecializationIgnored = 64,
  IsSpecializationInRecentExperienceRequired = 65,
  IsIndustryIgnored = 66,
  IsIndustryInRecentExperienceRequired = 67,
  IsSeniorityLevelIgnored = 68,
  WorkSchedule = 69,
  CustomerName2 = 70,
  HardSkills = 71,
  SoftSkills = 72
}
